// extracted by mini-css-extract-plugin
export default {"user_list_wrapper":"Messages_user_list_wrapper__Z-OMu"};